import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function MagazinHero() {
  return <section className="relative pt-32 pb-24 lg:pt-44 lg:pb-32 bg-[#4F2E7E] overflow-hidden" data-id="element-1580">
      {/* Decorative glows */}
      <div className="absolute top-1/4 left-1/2 w-[600px] h-[600px] bg-brand-gold/[0.08] rounded-full blur-3xl -translate-x-1/2 pointer-events-none" data-id="element-1581" />
      <div className="absolute -bottom-32 right-0 w-[500px] h-[500px] bg-brand-gold/[0.06] rounded-full blur-3xl pointer-events-none" data-id="element-1582" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-1583">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-brand-gold/15 border border-brand-gold/40 text-brand-gold text-xs md:text-sm font-bold uppercase tracking-[0.25em] mb-8" data-id="element-1584">
          <Sparkles className="w-4 h-4" data-id="element-1585" />
          Cursuri & Programe
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-heading text-5xl md:text-6xl lg:text-[88px] font-bold text-white mb-6 leading-[1.05] text-balance" data-id="element-1586">
          Alege parcursul tău
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="font-subtitle text-lg md:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed" data-id="element-1587">
          De la primul pas spre liniștea interioară până la transformarea
          profundă prin abundență, iubire și prezență. Toate cursurile,
          terapiile și evenimentele Academiei de Abundență, într-un singur loc.
        </motion.p>
      </div>
    </section>;
}